<template>
    <div class="home">
        <v-alert v-if="getAuthError" type="error">
            <p>{{ getAuthError }}</p>
        </v-alert>

        <div class="login d-flex justify-center mb-6" v-if="!isAuthenticated">
            <v-btn :href="loginUrl" color="primary" class="loginButton">Login</v-btn>
        </div>
        <img
            style="position: relative; height: 300px; margin: 50px"
            src="../../static/images/newInvaioLogo.webp"
            alt="invaio logo"
        />
    </div>
</template>

<script>
import { defineComponent } from "vue";

import { mapGetters } from "vuex";

export default defineComponent({
    name: "HomePage",

    computed: {
        ...mapGetters(["getAuthError", "isAuthenticated", "loginUrl"]),
    },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    text-align: center;
    color: #b4cdc0;
    height: 100%;
    background-image: url("../../static/images/oranges.webp");
}

.login {
    align-content: center;
    background-color: rgba(255, 255, 255, 0.75);
    width: 100%;
}

.loginButton {
    margin: 20px;
}
</style>
